import { ChakraProvider, ChakraProviderProps } from "@chakra-ui/react";
import { Snackbar } from "../components/Snackbar";
import { SnackBarConsumer, SnackBarProvider } from "../context/SnackbarContext";

export const AppThemeProvider = ({
  children,
  theme,
  link,
  ...props
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  link?: any;
} & ChakraProviderProps) => {
  return (
    <ChakraProvider
      theme={{
        ...theme,
        nextLink: link,
      }}
      toastOptions={{
        defaultOptions: {
          position: "top-right",
          duration: 5000,
        },
      }}
      {...props}
    >
      {children}
      <SnackBarProvider>
        <SnackBarConsumer>
          {([state]) => <Snackbar position="bottom-left" {...state} />}
        </SnackBarConsumer>
      </SnackBarProvider>
    </ChakraProvider>
  );
};
